import React, { useState } from "react";
// ---- Popup Dialog Component ----
function PopupDialog({ open, onClose, onboardingUrl }) {
    const slides = [
        {
            title: "Cubble's Purpose",
            content: <p style={{ fontStyle: "italic", color: "#90b4fe", marginBottom: 10 }}>"We're here to share our stories, listen to yours, and make connections that matter."</p>,
        },
        {
            title: "Mission & Vision",
            content: (
                <>
                    <div><b>Mission</b> – Reduce the global loneliness epidemic by nurturing <b>safe, genuine connections</b> that lead to real-world meetings.</div>
                    <div><b>Vision</b> – A world where every person can rely on a trusted local <b>"bubble"</b> of supportive peers within 48 hours of reaching out.</div>
                </>
            ),
        },
        {
            title: "Core Values",
            content: (
                <table style={{ fontSize: "1rem", margin: "0 0 8px 0", color: "#cddafd" }}>
                    <tbody>
                        <tr><td><b>Empathy-first</b></td><td style={{ paddingLeft: 10 }}>Emotional safety over vanity metrics.</td></tr>
                        <tr><td><b>Inclusivity</b></td><td style={{ paddingLeft: 10 }}>Moderated, respectful, and diverse bubbles.</td></tr>
                        <tr><td><b>Privacy</b></td><td style={{ paddingLeft: 10 }}>No public browsing. Encrypted data.</td></tr>
                        <tr><td><b>Science-led</b></td><td style={{ paddingLeft: 10 }}>Features grounded in psychology research.</td></tr>
                    </tbody>
                </table>
            ),
        },
        {
            title: "Our Story",
            content: (
                <ul style={{ paddingLeft: 18, color: "#cddafd", fontSize: "1rem" }}>
                    <li><b>Founded</b> in 2023, Edinburgh.</li>
                    <li><b>Why</b> – Rising Gen Z loneliness & superficial dating apps inspired Cubble.</li>
                </ul>
            ),
        },
        {
            title: "Get Started – Onboarding Form",
            content: (
                <>
                    <p>Please read the onboarding doc and fill out the form to get full access.</p>
                    <a href={onboardingUrl} target="_blank" rel="noopener noreferrer"
                        style={{ display: "inline-block", background: "#3b5fff", color: "#fff", fontWeight: 600, borderRadius: 8, padding: "12px 22px", textDecoration: "none", margin: "20px 0 8px 0" }}>
                        Go to Onboarding Form
                    </a>
                </>
            ),
        },
    ];

    const [step, setStep] = useState(0);
    if (!open) return null;

    return (
        <div style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(18,22,28,0.92)", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{ position: "relative", minWidth: 330, maxWidth: 420, background: "#22283a", borderRadius: 20, boxShadow: "0 12px 32px rgba(0,0,0,0.32)", padding: 32, color: "#fff" }}>
                <button onClick={() => { setStep(0); onClose(); }} aria-label="Close"
                    style={{ position: "absolute", top: 16, right: 18, background: "none", border: "none", fontSize: 26, fontWeight: 700, color: "#aaa", cursor: "pointer" }}>
                    ×
                </button>
                <h2 style={{ fontWeight: 700, fontSize: 22, color: "#90b4fe", marginBottom: 10 }}>{slides[step].title}</h2>
                <div style={{ marginBottom: 22, lineHeight: 1.5 }}>{slides[step].content}</div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <button disabled={step === 0} onClick={() => setStep(step - 1)} style={{ opacity: step === 0 ? 0.6 : 1, cursor: step === 0 ? "not-allowed" : "pointer", background: "#262f45", color: "#90b4fe", borderRadius: 8, padding: "10px 20px", border: "none" }}>Back</button>
                    <div style={{ display: "flex", gap: 4 }}>{slides.map((_, i) => (<span key={i} style={{ width: 8, height: 8, borderRadius: "50%", background: i === step ? "#90b4fe" : "#3b4067" }} />))}</div>
                    {step < slides.length - 1 ? (
                        <button onClick={() => setStep(step + 1)} style={{ background: "#3b5fff", color: "#fff", borderRadius: 8, padding: "10px 20px", border: "none" }}>Next</button>
                    ) : (
                        <button onClick={() => { setStep(0); onClose(); }} style={{ background: "#262f45", color: "#90b4fe", borderRadius: 8, padding: "10px 20px", border: "none" }}>Close</button>
                    )}
                </div>
            </div>
        </div>
    );
}

export default PopupDialog;